import { t } from "@lingui/macro";
import { WfButton } from "@WahooFitness/redesignr";
import WfActionGroup from "@WahooFitness/redesignr/dist/Actions/WfActionGroup/WfActionGroup.js";

const UpdateAndHistorySection = ({
  openUpdateProfileDrawer,
  hasProfile,
  showHistoryButton,
  navigateToHistory,
  historyButtonText,
  buttonIcon,
}: {
  openUpdateProfileDrawer: () => void;
  hasProfile: boolean;
  showHistoryButton?: boolean;
  navigateToHistory?: () => void;
  historyButtonText?: string;
  buttonIcon: React.ReactElement;
}) => {
  return (
    <WfActionGroup fullWidth orientation="vertical">
      <WfButton
        hierarchy="primary"
        size="large"
        startIcon={buttonIcon}
        onClick={openUpdateProfileDrawer}
        fullWidth
      >
        {hasProfile ? t`Update profile` : t`Start profiling`}
      </WfButton>
      {showHistoryButton && navigateToHistory && historyButtonText && (
        <WfButton hierarchy="tertiary" size="large" onClick={navigateToHistory} fullWidth>
          {historyButtonText}
        </WfButton>
      )}
    </WfActionGroup>
  );
};

export default UpdateAndHistorySection;
